import { useState, useCallback } from 'react';

export interface AiApiPostOptions {
  url?: string;
  payload: any;
}

export function useAiApiPost(defaultUrl: string = '/api/ai/execute') {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [result, setResult] = useState<any>(null);

  const post = useCallback(async (options: AiApiPostOptions) => {
    setLoading(true);
    setError(null);
    setResult(null);
    try {
      const headers: Record<string, string> = { 'Content-Type': 'application/json' };
      const token = localStorage.getItem('cb_token');
      if (token) {
        headers['Authorization'] = `Bearer ${token}`;
      }
      const response = await fetch(options.url || defaultUrl, {
        method: 'POST',
        headers,
        body: JSON.stringify(options.payload)
      });
      const data = await response.json();
      if (!response.ok) {
        // Show error code and description if available
        let errorMsg = data?.error || 'API error';
        if (data?.message) {
          errorMsg += `: ${data.message}`;
        }
        setError(errorMsg);
        console.log("API error:", data.error);

      } else {
        console.log("API response data:", data);
        setResult(data);
      }
    } catch (err: any) {
      setError(err.message || 'Network error');
    } finally {
      setLoading(false);
    }
  }, [defaultUrl]);

  return { post, loading, error, result };
}
